module.exports = __webpack_public_path__ + "static/img/hcp-seg-brintellix-4.b369de72.png";